import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import { LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import FilogixLoader from "./filogix-loader";
import FilogixDetails from "./filogix-details.vue";
import { showToast } from "@Shared/utils/constants";
import Err from "../../../../routes/error";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FilogixDetailsContainer",
  components: {
    FilogixDetails,
    FilogixLoader
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    allowSave: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      submitLoading: false
    };
  },
  computed: _objectSpread({}, mapState("SettingsStore", ["filogixDetails"])),
  watch: {
    saving(value) {
      if (!value) return;
      this.$refs.filogixDetails.handleSubmit();
    }
  },
  async mounted() {
    await this.loadDetails();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS])), {}, {
    async handleSubmit(filogixData) {
      this.loading = true;
      try {
        await this.UPDATE_FILOGIX_DETAILS(filogixData);
        await this.loadDetails();
        showToast("success", "filogixDetailsUpdated");
        this.$emit("finish-saving", true);
      } catch (e) {
        this.$emit("finish-saving", false);
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    async loadDetails() {
      await this.LOAD_FILOGIX_DETAILS();
      this.loading = false;
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    }
  })
});